module.exports = __webpack_public_path__ + "static/media/em-224.9bbb70d5.png";